import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  BreadcrumbsInterface,
  BreadcrumbsState,
} from "../../../entities/Breadcrumbs";

const initialState: BreadcrumbsState = {
  breadcrumbs: [],
};

const breadcrumbsSlice = createSlice({
  name: "breadcrumbs",
  initialState,
  reducers: {
    setBreadcrumbs: (
      state: BreadcrumbsState,
      action: PayloadAction<BreadcrumbsInterface>,
    ) => {
      const clonedBreadcrumbs = [...state.breadcrumbs];
      clonedBreadcrumbs[action.payload.level] = action.payload;
      state.breadcrumbs = clonedBreadcrumbs;
    },
    removeBreadcrumbsItem: (
      state: BreadcrumbsState,
      action: PayloadAction<{ level: number }>,
    ) => {
      const clonedBreadcrumbs = [...state.breadcrumbs];
      const reducedBreadcrumbs = clonedBreadcrumbs.slice(
        action.payload.level - 1,
        1,
      );
      state.breadcrumbs = reducedBreadcrumbs;
    },
  },
});

export const { setBreadcrumbs, removeBreadcrumbsItem } =
  breadcrumbsSlice.actions;

export default breadcrumbsSlice.reducer;
